export enum Endpoints {
  ORGS = "/sso/Organisation",
  USERS = "/sso/User",
  PRODUCTS = "/sso/Software",
  USER_PRODUCTS = "/sso/UserSoftware",
  RESET_PASSWORD = "/sso/ResetPassword",
  ACCOUNT = "/sso/Account",
  LOGIN = "/sso/Login",
  REGISTRATION = "/sso/Registration",
  BANNED_IP = "/sso/BanList",
  API_ACCOUNTS = "/sso/APIAccount",
  API_ACCOUNT_PRODUCTS = "/sso/APIAccountSoftware",
  API_ACCOUNT_KEYS = "/sso/ApiAccountKey",
  BILLED_OPERATIONS = "/sso/BilledOperation",
  LICENCES = "/sso/Licence",
  SOFTWARE = "/sso/Software",
  SOFTWARE_LICENCES = "/sso/SoftwareLicence",
  BILLABLE_OPERATIONS = "/sso/BillableOperations",
  PRICING = "/sso/Pricing",
  ORDERS = "/sso/Order",
  TRACC_Usages = "/sso/TRACCUsage",
  COUNTRIES = "/sso/Countries",
  CURRENCY = "/sso/Currency",
  PENDING_LICENCE_PURCHASE = "/sso/PendingLicencePurchase",
}
